(function (){
    'use strict';

    angular
        .module('app')
        .directive('confirmPasswordValidate', confirmPasswordValidate);

    function confirmPasswordValidate() {
       return {
           restrict:'A',
           require:'ngModel',
           scope:{
               confirmPasswordValidate: '='
           },
           link:link,
       };

        function link(scope, element, attrs, ctrl) {
            scope.$watch(scope.confirmPasswordValidate, function() {
                var validator = function (value) {
                    var testValue = element.val() == scope.confirmPasswordValidate;

                    if(scope.confirmPasswordValidate !=='' && typeof scope.confirmPasswordValidate !== 'undefined'){
                        if (testValue && typeof element.val() !== 'undefined') {
                            ctrl.$setValidity('confirmPasswordValidate', true);
                            $('#confirmPassword').parent().removeClass('has-error');
                            $('#confirmPassword').parent().find("span").remove();
                        } else {
                            ctrl.$setValidity('confirmPasswordValidate', false);
                            $('#confirmPassword').parent().removeClass('has-error');
                            $('#confirmPassword').parent().find("span").remove();
                            $('#confirmPassword').parent().addClass('has-error');
                            $('#confirmPassword').parent().append("<span class='help-block'>Please, confirm the password typed in password field!</span>");
                        }
                    }

                    return value;
                };

                ctrl.$parsers.unshift(validator);
                ctrl.$formatters.unshift(validator);
            });

        }
    }
})();